import React from "react";
import "./VoicesSection.css"
import Container from "react-bootstrap/Container";
import VoiceSection from "../../AngelAiCustomPreEvent/Speakers/Speakers"

const Voices = ({webpageData})=>{

    return(
        <>
            <div className="voices-div">
            <p className="voices-div-text">Voices That Shaped the Dialogue</p>
         </div>
      <Container>
         {/* <div className="voices-div-content">
        <div className="voices-div-wrapper">
  <svg
    className="voices-div-svg"
    width="100%"
    height="60"
    viewBox="0 0 600 60"
    preserveAspectRatio="none"
  >
    <path
  d="
    M100,0
    Q94,0 88,6
    L60,60
    L540,60
    L512,6
    Q506,0 500,0
    L100,0
    Z"
  fill="#7C3AED"
/>
  </svg>
  <div className="voices-div-text">Voices That Shaped the Dialogue</div>
</div> */}
<div className="voices-div-changes">
         <VoiceSection  webpageData={webpageData} />
         </div>
         {/* </div> */}
         </Container>
         </>
    )
}

export default Voices;